// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"84":"0762ce72","484":"cb56c776","527":"c98f8b17","723":"4a200f04"}[chunkId] + ".js";
};